import { Modal } from 'antd'
import dayjs from 'dayjs'
import React, { useCallback, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useGetEventUserQuery } from '../../api/eventUser.api'
import { useCreateEventLogMutation } from '../../api/v2/eventLogs'
import { useMyContext } from '../../context/context'
import useActionLog from '../../hooks/useActionLog'
import useActive from '../../hooks/useActive'
import useHistoryCustom from '../../hooks/useHistoryCustom'
import useSettingsV2 from '../../hooks/useSettingsV2'
import useTranslations from '../../hooks/useTranslations'
import useWebsocket from '../../hooks/useWebsocket'
import { IUserEvent } from '../../interfaces/userEvent'
import EventUserPollRightApi from '../../services/api/EventUserPollRight'
import UserEventApi from '../../services/api/UserEvent.api'
import UserEventDayApi from '../../services/api/UserEventDay.api'
import ROUTES from '../../services/routes'
import Button from '../../shared/form/button'
import HTML from '../../components/HTML'
import Chat from './chat'
import Poll from './poll'
import Questions from './Questions'
import UserEmotions from './UserEmotions'
import Video from './video'
import WordCloudResponse from './WordCloudResponse'

const RightModule = ({ data, right, settings, userEvent }: any) => {
  if (!data) return null
  if (!data.eventLive) return null
  if (settings?.FO_MEETING_MODE_OUT_ACTIVE && !userEvent.isRemote && userEvent.isOut) {
    return (
      <HTML
        className="live-flex"
        style={{ width: settings?.FO_MEETING_MODULE_LIVE_BELOW ? '100%' : '50%', padding: '20px 40px' }}
        name="FO_MEETING_MODE_OUT_HTML"
        value={undefined}
      />
    )
  }
  if (data.eventLive.activeModule === 'poll' && right?.hasRightToVote)
    return (
      <div
        className="live-flex"
        style={{ width: settings?.FO_MEETING_MODULE_LIVE_BELOW ? '100%' : '50%', padding: '20px 40px', fontWeight: 500 }}
      >
        <Poll data={data} />
        <UserEmotions />
      </div>
    )
  if (data.eventLive.activeModule === 'question' && data.question)
    return (
      <div
        className="live-flex"
        style={{ width: settings?.FO_MEETING_MODULE_LIVE_BELOW ? '100%' : '50%', padding: '20px 0px', fontWeight: 500 }}
      >
        <Questions data={data} />
        <UserEmotions />
      </div>
    )
  if (data.eventLive.activeModule === 'chat')
    return (
      <div
        className="live-flex"
        style={{ width: settings?.FO_MEETING_MODULE_LIVE_BELOW ? '100%' : '50%', padding: '20px 40px', fontWeight: 500 }}
      >
        <Chat />
        <UserEmotions />
      </div>
    )
  if (data.eventLive.activeModule === 'wordcloud')
    return (
      <div
        className="live-flex"
        style={{ width: settings?.FO_MEETING_MODULE_LIVE_BELOW ? '100%' : '50%', padding: '20px 40px', fontWeight: 500 }}
      >
        <WordCloudResponse data={data} />
        <UserEmotions />
      </div>
    )
  return null
}

const Live = () => {
  const [isStarted, setIsStarted] = useState(false)
  const [userEvent, setUserEvent] = useState<IUserEvent>()
  const [hide, setHide] = useState(false)
  const [right, setRight] = useState<any>(null)
  const [isOut, setIsOut] = useState(false)

  const history = useHistoryCustom()
  const location = useLocation()
  const { isActive } = useActive()

  const [data]: any = useWebsocket(false, isStarted)
  const { event, userId, myContext } = useMyContext() as any
  const { settings } = useSettingsV2() as any
  const { t } = useTranslations()

  const [createEventLog] = useCreateEventLogMutation()
  const { data: eventUser } = useGetEventUserQuery(myContext)

  useActionLog({ actionId: 3 })

  const eventDays = event.days

  const updateIsStarted = useCallback(() => {
    const v = settings?.startAt && dayjs(new Date(settings.startAt)).isBefore(dayjs())
    console.log(settings?.startAt)
    console.log('startAt', v)
    setIsStarted(v)
    return v
  }, [settings])

  useEffect(() => {
    let interval: any
    const cb = () => {
      const v = updateIsStarted()
      if (v && interval) {
        clearInterval(interval)
      }
    }

    interval = setInterval(cb, 10000)
    cb()

    return () => clearInterval(interval)
  }, [updateIsStarted])

  useEffect(() => {
    if (isStarted && myContext) {
      console.log('Create event log A')
      createEventLog({ ...myContext, type: 'IN' })
    }
  }, [createEventLog, isStarted, myContext])

  useEffect(() => {
    let timeout: any

    console.log(settings?.FO_MEETING_INACTIVE_POPUP)

    if (settings?.FO_MEETING_INACTIVE_POPUP && eventUser?.UserEvent?.isRemote) {
      if (!isActive && myContext && !isOut) {
        timeout = setTimeout(() => {
          console.log('Create event log B')
          createEventLog({ ...myContext, type: 'OUT' })
          setIsOut(true)
        }, 60000)
      }

      if (isActive && timeout) {
        clearTimeout(timeout)
      }

      if (isActive && isOut) {
        createEventLog({ ...myContext, type: 'IN' })
        setIsOut(false)
      }
    }

    return () => {
      clearTimeout(timeout)
    }
  }, [createEventLog, eventUser, isActive, isOut, myContext, settings])

  useEffect(() => {
    if (userId)
      new UserEventApi()
        .getByUserId(userId)
        .then(({ UserEvent }) => {
          if (!UserEvent || (!UserEvent.registered && !UserEvent.responded && window.location.pathname !== '/satisfaction')) {
            history.push(ROUTES.EVENTS_INSCRIPTION)
          }
          return UserEvent
        })
        .then(setUserEvent)
        .then(() => new EventUserPollRightApi(userId).findOne())
        .then(setRight)
  }, [history, settings.FO_MEETING_PARTICIPATON_HIDE, userId])

  const setPresent = useCallback(async () => {
    if (!settings?.startAt) return false

    const date = new Date(settings.startAt)
    if (date > new Date()) return false

    const offset = date.getTimezoneOffset()
    date.setMinutes(date.getMinutes() - offset)
    const today = date.toISOString().substr(0, 10)

    const find = eventDays.find((ed: any) => ed.day === today)
    if (!find) return false

    await Promise.all([
      new UserEventDayApi(find.id).updateOrCreateOne(userId, {
        present: true,
        presentAt: new Date().toLocaleTimeString(),
      }),
      new UserEventApi().updateOrCreateOne(userId, { isRemote: true }),
    ])

    // history.reload()
    return true
  }, [eventDays, settings, userId])

  useEffect(() => {
    if (!userEvent || !settings?.startAt) return
    if (userEvent.present) return

    const interval = setInterval(() => {
      setPresent().then(ok => {
        if (ok) clearInterval(interval)
      })
    }, 10000)
    setPresent().then(ok => {
      if (ok) clearInterval(interval)
    })

    return () => {
      clearInterval(interval)
    }
  }, [setPresent, settings, userEvent, userId])

  if (!userEvent || !userEvent.registered) return <div style={{ textAlign: 'center' }}>{t('NOT_REGISTERED_MESSAGE')}</div>

  if (!settings?.startAt)
    return <div style={{ textAlign: 'center' }}>Vous devez configurer la date l'heure du live youtube dans le back office.</div>

  if (!isStarted && location.search !== '?admin') {
    return (
      <div>
        {settings?.htmlBeforeLive && (
          <HTML style={{ backgroundColor: settings?.bgColorBeforeLive }} name="htmlBeforeLive" value={undefined} className={undefined} />
        )}
      </div>
    )
  }

  return (
    <div>
      <Modal title="Etes-vous toujours avec nous ?" visible={!isActive && settings?.FO_MEETING_INACTIVE_POPUP} footer={null}>
        <div>{t('LIVE_NOT_HERE_MESSAGE')}</div>
      </Modal>
      <HTML style={{ backgroundColor: settings?.bgColorLiveTop }} name="htmlLiveTop" value={undefined} className={undefined} />
      {!settings?.hideVideoLive && (userEvent.isRemote || !userEvent.present) && (
        <Button
          style={{ position: 'fixed', bottom: 0, zIndex: 100 }}
          label={hide ? 'Afficher la vidéo' : 'Cacher la vidéo'}
          onClick={() => setHide(prev => !prev)}
        />
      )}
      <div
        style={{
          display: 'flex',
          flexDirection: settings?.FO_MEETING_MODULE_LIVE_BELOW ? 'column' : 'row',
          justifyContent: 'center',
          flexWrap: 'wrap',
          alignItems: 'center',
          padding: '15px 0',
        }}
      >
        {!settings?.hideVideoLive && (userEvent.isRemote || !userEvent.present) && <Video hide={hide} />}
        <RightModule data={data} right={right} settings={settings} userEvent={userEvent} />
      </div>
      <HTML style={{ backgroundColor: settings?.bgColorLiveBottom }} name="htmlLiveBottom" value={undefined} className={undefined} />
    </div>
  )
}

function LivePage() {
  const { settings } = useSettingsV2() as any

  if (settings?.FO_MEETING_LIVE_IS_CLOSE) {
    return <div dangerouslySetInnerHTML={{ __html: settings?.FO_MEETING_LIVE_IS_CLOSE_HTML || 'Le live a été clôturé' }} />
  }

  return <Live />
}

export default LivePage
